import React, { Component } from "react";

class Breadcrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {

    }

    render() {
        const { title } = this.props;
        return (
            <React.Fragment>
                <div className="breadcumb-wrapper">
                    <div className="container">
                        <div className="breadcumb-content">
                            <h1 className="breadcumb-title">{title}</h1>
                            <ul className="breadcumb-menu">
                                <li><a href={process.env.PUBLIC_URL + "/"}>Home</a></li>
                                <li className="active">{title}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Breadcrumb;
